export default "__VITE_ASSET__BiM6JdEV__"